import { render, staticRenderFns } from "./SvgLogoCollection.vue?vue&type=template&id=933f816e&"
import script from "./SvgLogoCollection.vue?vue&type=script&lang=js&"
export * from "./SvgLogoCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports